<template>
  <div>
    <div class="banner" id="banner">
      <div class="banner-container"></div>
    </div>
    <div class="banner_box_media">
      <div class="banner_center_media">
        <div class="media_title">{{ $t("portusAir.history") }}</div>
        <div class="history_flex mb23">
          <div class="portusAir_history">{{ $t("portusAir.history1") }}</div>
          <div class="portusAir_history">{{ $t("portusAir.history2") }}</div>
        </div>
        <div class="history_flex mb47">
          <div class="portusAir_history">{{ $t("portusAir.history3") }}</div>
          <div class="portusAir_history">{{ $t("portusAir.history4") }}</div>
        </div>
        <div class="history_flex mb54">
          <div class="historyImg">
            <img :src="$t('picture.historyImg1')" alt="" />
          </div>

          <div class="historyImg">
            <img :src="$t('picture.historyImg2')" alt="" />
          </div>

          <div class="historyImg">
            <img :src="$t('picture.historyImg3')" alt="" />
          </div>

          <div class="historyImg">
            <img :src="$t('picture.historyImg4')" alt="" />
          </div>
        </div>

        <div class="history_line">
          <div class="history_triangle history_line1">
            <img src="../../../public/static/img/portus/triangle.png" alt="" />
          </div>

          <div class="history_triangle history_line2">
            <img src="../../../public/static/img/portus/triangle.png" alt="" />
          </div>

          <div class="history_triangle history_line3">
            <img src="../../../public/static/img/portus/triangle.png" alt="" />
          </div>

          <div class="history_triangle history_line4">
            <img src="../../../public/static/img/portus/triangle.png" alt="" />
          </div>
        </div>

        <div class="history_explain">
          <div class="history_explain_every l67">
            <div class="w145">{{ $t("portusAir.line1") }}</div>
          </div>
          <div class="history_explain_every l420">
            <div class="w145">{{ $t("portusAir.line2") }}</div>
          </div>
          <div class="history_explain_every r400">
            <div class="w145">{{ $t("portusAir.line3") }}</div>
          </div>
          <div class="history_explain_every r97">
            <div class="w145">{{ $t("portusAir.line4") }}</div>
          </div>
        </div>

        <div class="pl29">
          <div class="fz28">{{ $t("portusAir.consult") }}</div>
          <div class="fz22">
            {{ $t("portusAir.consultContent") }}
          </div>
        </div>
      </div>
    </div>

    <div class="banner_box_media" style="background-color: #f7f7f7">
      <div class="banner_center_media">
        <div class="media_title">{{ $t("portusAir.system") }}</div>
        <img style="margin-bottom: 54px" :src="$t('picture.system')" alt="" />
        <div class="wordCenter" :style="{ width: $t('style.width') }">
          <div>{{ $t("portusAir.service") }}</div>
          <div>{{ $t("portusAir.technology") }}</div>
          <div>{{ $t("portusAir.pay") }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.banner .banner-container {
  padding-top: 86px;
  min-height: 638px;
  background-image: url("http://travelmall.portus.cn/2023/04/6260ba00c1a047088a6d2dabbfa0f4c9.png");
  background-repeat: no-repeat center;
  background-size: 100% 100%;
}
</style>
